import type ItemCategoryRM from 'ab-requestModels/itemCategory/itemCategory.requestModel';

import { isValidTextInput } from '@acceligentllc/shared/utils/text';

export function validate(values: ItemCategoryRM) {
	const errors: ValidationErrors = {};

	if (!isValidTextInput(values.name)) {
		errors.name = 'Name is required';
	}

	return errors;
}
